import {
  collection,
  CollectionReference,
  doc,
  DocumentData,
} from "firebase/firestore";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { db, storage } from "../../firebaseConfig";

/**
 * Get a reference to a specific document base on the collection name and the id of the document
 * @param {String} collectionName
 * @param {String} id
 * @returns {CollectionReference<DocumentData>}
 */
const getDocumentRef = (collectionName, id) => {
  return doc(db, collectionName, id);
};

/**
 * Get the reference to the collection base on the collection name
 * @param {String} collectionName
 * @returns {CollectionReference<DocumentData>}
 */
const getCollectionRef = (collectionName) => {
  return collection(db, collectionName);
};

/**
 *
 * @param {String} folder
 * @param {Object} file
 * @param {() => {}} getImageURL
 * @param {() => {}} getProgress
 * @param {() => {}} setUploading
 */
const uploadImage = (folder, file, getImageURL, getProgress, setUploading) => {
  const filename = `${Date.now()}-${file.name}`;

  // Preparing image upload
  const storageRef = ref(storage, `${folder}/${filename}`);

  const uploadTask = uploadBytesResumable(storageRef, file);

  uploadTask.on(
    "state_changed",
    (snapshot) => {
      const progress = Math.floor(
        (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      );
      getProgress(progress);
    },
    (error) => {
      console.error(error);
      setUploading(false);
    },
    () => {
      getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
        setUploading(false);
        getImageURL(downloadURL);
      });
    }
  );
};

export { getDocumentRef, getCollectionRef, uploadImage };
